import { z } from 'zod';

import { Beschaeftigung } from '../../../LoanRequest/applicant/Beschaeftigung';
import { Personendaten } from '../../../LoanRequest/applicant/Personendaten';
import { Wohnsituation } from '../../../LoanRequest/applicant/Wohnsituation';
import { Dispositionskredit } from '../../../LoanRequest/haushalt/verbindlichkeiten/Dispositionskredit';
import { Immobiliendarlehen } from '../../../LoanRequest/haushalt/verbindlichkeiten/Immobiliendarlehen';
import { Kontokorrentkredit } from '../../../LoanRequest/haushalt/verbindlichkeiten/Kontokorrentkredit';
import { Kreditkarte } from '../../../LoanRequest/haushalt/verbindlichkeiten/Kreditkarte';
import { Leasing } from '../../../LoanRequest/haushalt/verbindlichkeiten/Leasing';
import { RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit } from '../../../LoanRequest/haushalt/verbindlichkeiten/RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit';
import { schemaLoanRequest } from '../../../LoanRequest/LoanRequest';

export const schemaApplicantCreation = z.object({
    ausgaben: schemaLoanRequest.shape.haushalt.shape.ausgaben,
    beschaeftigung: Beschaeftigung,
    dispositionskredite: z.array(Dispositionskredit).default([]),
    einnahmen: schemaLoanRequest.shape.haushalt.shape.einnahmen,
    geschaeftskredite: z.array(RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit).default([]),
    immobilien: schemaLoanRequest.shape.haushalt.shape.immobilien,
    immobiliendarlehen: z.array(Immobiliendarlehen).default([]),
    kinder: schemaLoanRequest.shape.haushalt.shape.kinder,
    kontokorrentkredite: z.array(Kontokorrentkredit).default([]),
    kreditkarten: z.array(Kreditkarte).default([]),
    leasings: z.array(Leasing).default([]),
    personendaten: Personendaten,
    ratenkredite: z.array(RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit).default([]),
    sonstigeVerbindlichkeiten: z.array(RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit).default([]),
    wohnsituation: Wohnsituation,
});

export type ApplicantCreation = z.infer<typeof schemaApplicantCreation>;
